import { render, staticRenderFns } from "./formbuilderViewStep.vue?vue&type=template&id=2ebf03ae&scoped=true"
import script from "./formbuilderViewStep.vue?vue&type=script&lang=js"
export * from "./formbuilderViewStep.vue?vue&type=script&lang=js"
import style0 from "./formbuilderViewStep.vue?vue&type=style&index=0&id=2ebf03ae&prod&lang=scss"
import style1 from "./formbuilderViewStep.vue?vue&type=style&index=1&id=2ebf03ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebf03ae",
  null
  
)

export default component.exports